import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowOutExternal12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconArrowOutExternal12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.5 1a.5.5 0 0 0 0 1h1.793L5.646 5.646a.5.5 0 1 0 .708.708L10 2.707V4.5a.5.5 0 0 0 1 0V1zM1 3.5A1.5 1.5 0 0 1 2.5 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 1 0v3A1.5 1.5 0 0 1 8.5 11h-6A1.5 1.5 0 0 1 1 9.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowOutExternal12);
